define([
    'common/ui/view/svg/text/area',
    'common/ui/view/svg/text/path',
    'common/ui/view/svg/index',
    'victor'
], function(
    TextareaView,
    TextpathView,
    SVGView,
    Victor
    ) {
    var Shape = SVGView.extend({
        className: 'shape',

        initialize: function(params) {
            Shape.__super__.initialize.call(this, params);
            this._width = this.params.width;
            this._height = this.params.height;
            this._offset = this.params.offset ? this.params.offset : {x:0,y:0};
        },

        height: function() {
            return this._height;
        },

        width: function() {
            return this._width;
        },

        offset: function() {
            return this._offset;
        },

        imageSize: function() {
            return this._width > this._height ? this._width : this._height;
        },

        imageOffset: function() {
            var imageSize = this.imageSize();
            return {
                x: - (imageSize - this._width) / 2,
                y: - (imageSize - this._height) / 2
            };
        },

        setImage: function(imageId) {
            if(!imageId) {
                this.$el.style('fill', null);
                return;
            }

            this.$el.style('fill', 'url(#' + imageId + ')');
        },

        /**
         * Shape 内に複数行のテキストを表示するための TextareaView を返す
         *
         * @param params
         * @returns {TextareaView}
         */
        createTextArea: function(params) {
            params = _.extend({}, params);
            var strokeOffset = params.strokeOffset || 64;
            var width = this._width - strokeOffset;
            var height = this._height - strokeOffset;
            var offset = {
                x: - width / 2,
                y: - height / 2
            };

            return new TextareaView({
                width: width,
                height: height,
                offset: offset
            });
        },

        /**
         * Stroke 上部に表示にテキストを表示するための TextpathView を返す
         *
         * @param params
         * @returns {TextpathView}
         */
        createTextpath: function(params) {
            const fromX = - this._width / 2;
            const fromY = - this._height / 2;
            const toX = this._width / 2;
            const toY = - this._height / 2;
            const path = `M ${fromX},${fromY} L ${toX},${toY}`;
            return new TextpathView({
                id: params.id,
                path: path,
                offset: '50%'
            });
        },

        /**
         * Shape の右下半分の stroke 上の座標を interval 間隔でリストにして返す
         *
         * @param params
         * @returns {Array}
         */
        getBottomRightPoints: function(params) {
            var interval = params.interval;
            var points = [];
            var offset = 24;
            var i = 0;

            while(true) {
                var point = {
                    x: this._width / 2 - interval * i - offset,
                    y: this._height / 2
                };

                if(point.x < interval) {
                    break;
                }
                points.push(point);
                i++;
            }

            return points;
        },

        /**
         * Shape の左下半分の stroke 上の座標を interval 間隔でリストにして返す
         *
         * @param params
         * @returns {Array}
         */
        getBottomLeftPoints: function(params) {
            var interval = params.interval;
            var points = [];
            var offset = 24;
            var i = 0;

            while(true) {
                var point = {
                    x: - this._width / 2 + interval * i + offset,
                    y: this._height / 2
                };

                if(point.x > interval) {
                    break;
                }
                points.push(point);
                i++;
            }

            return points;
        },

        /**
         * 中心から Vector 方向に伸ばした線と Border (に offset を付加した) が
         * 交わる Point を返す。
         * Point は中心からの相対ベクトルで返される。
         *
         * @param {Victor} direction - ノード中心からのベクトル、x, y は SVG に座標合わせる
         * @param {number} [offset = 0] - Border のオフセット(px)。
         * @returns {Victor}
         */
        getBorderPoint: function(direction, offset) {
            // SVG 座標だと角度が通常と反対になるので分かりやすく修正
            var angle = (- direction.angleDeg() + 360) % 360;
            offset = offset ? offset : 0;
            var height = this._height;
            var width = this._width;
            var topRightAngle = Math.atan2(height, width) / Math.PI * 180;

            if((0 <= angle && angle < topRightAngle) || (360 - topRightAngle <= angle && angle < 360)) {
                return Victor.fromObject({
                    x: width / 2 + offset,
                    y: - width / 2 * Math.tan(angle / 180 * Math.PI)
                });
            } else if(topRightAngle <= angle && angle < 180 - topRightAngle) {
                return Victor.fromObject({
                    x: height / 2 / Math.tan(angle / 180 * Math.PI),
                    y: -height / 2 - offset
                });
            } else if(180 - topRightAngle <= angle && angle < 180 + topRightAngle) {
                return Victor.fromObject({
                    x: - width / 2 - offset,
                    y: width / 2 * Math.tan(angle / 180 * Math.PI),
                });
            } else {
                return Victor.fromObject({
                    x: - height / 2 / Math.tan(angle / 180 * Math.PI),
                    y: height / 2 + offset
                });
            }
        },

        /**
         * 中心から Vector 方向に伸ばした線と Border (に offset を付加した) が
         * 交わる点での Border の法線ベクトル(Tangent) を返す。
         * Tangent は長さ 1 に正規化されている。
         *
         * @param {Victor} direction - ノード中心からのベクトル、x, y は SVG に座標合わせる
         * @param {number} [offset = 0] - Border のオフセット(px)。
         * @returns {Victor}
         */
        getBorderTangent: function(direction, offset) {
            // SVG 座標だと角度が通常と反対になるので分かりやすく修正
            const angle = (- direction.angleDeg() + 360) % 360;
            offset = offset ? offset : 0;
            var height = this._height;
            var width = this._width;
            var topRightAngle = Math.atan2(height, width) / Math.PI * 180;

            if((0 <= angle && angle < topRightAngle) || (360 - topRightAngle <= angle && angle < 360)) {
                return Victor.fromObject({
                    x: 1,
                    y: 0,
                });
            } else if(topRightAngle <= angle && angle < 180 - topRightAngle) {
                return Victor.fromObject({
                    x: 0,
                    y: -1,
                });
            } else if(180 - topRightAngle <= angle && angle < 180 + topRightAngle) {
                return Victor.fromObject({
                    x: -1,
                    y: 0,
                });
            } else {
                return Victor.fromObject({
                    x: 0,
                    y: 1,
                });
            }
        },

        renderSizeChanger: function() {
            if(!this._width || !this._height) {
                return;
            }
            /**
             * ChangerView は size 変更のための起点が異なるので
             * (右下の changer は左上、左上は右下がそれぞれ起点になる)
             * base を引数でとり、size 変更時に pos と base を返すことで
             * callback の側の処理を統一的に行えるようにする
             */
            var ChangerView = SVGView.extend({
                draggable: true,
                className: 'shape-size-changer',
                initialize: function(options) {
                    ChangerView.__super__.initialize.call(this, options);
                    this.base = Victor.fromObject(options.base);
                    this.pos = Victor.fromObject(options.pos);
                    this.offset = Victor.fromObject(options.offset);
                    this.path = options.path;
                },
                onRender: function() {
                    ChangerView.__super__.onRender.call(this);
                    this.transform(this.pos.clone().add(this.offset));
                    this.$el.append('path')
                        .attr('d', this.path);
                },
                onDrag: function(pos, dpos) {
                    this.pos.add(dpos);
                    this.transform(this.pos.clone().add(this.offset));
                    this.trigger('drag', this.pos.clone(), this.base);
                },
                onDragEnd: function(pos) {
                    this.trigger('dragend', this.pos.clone(), this.base);
                }
            });

            // bottom-right
            var changerView = new ChangerView({
                base: {x: - this._width / 2, y: - this._height / 2},
                pos: {x: this._width / 2, y: this._height / 2},
                offset: {x: 48, y: 48},
                path: 'M32,-32 L32,32 L-32,32'
            });
            this.$el.append(changerView.render().el);
            this.listenTo(changerView, 'drag', this.onSizeChange);
            this.listenTo(changerView, 'dragend', this.onSizeChangeEnd);

            // top-left
            changerView = new ChangerView({
                base: {x: this._width / 2, y: this._height / 2},
                pos: {x: - this._width / 2, y: - this._height / 2},
                offset: {x: -48, y: -48},
                path: 'M32,-32 L-32,-32 L-32,32'
            });
            this.$el.append(changerView.render().el);
            this.listenTo(changerView, 'drag', this.onSizeChange);
            this.listenTo(changerView, 'dragend', this.onSizeChangeEnd);
        },

        onSizeChange: function(pos, base) {
            this.$el.selectAll('.shape-in-changing').remove();
            var width = Math.abs(pos.x - base.x);
            var height = Math.abs(pos.y - base.y);
            var offset = {
                x: pos.x / 2 + base.x / 2,
                y: pos.y / 2 + base.y / 2
            };

            this.$el.append((new this.constructor({
                width: width,
                height: height,
                offset: offset
            })).render().el)
                .classed('shape-in-changing', true);

            this.trigger('change:size');
        },

        onSizeChangeEnd: function(pos, base) {
            var gridSize = 256;
            var width = Math.abs(Math.round((pos.x - base.x) / gridSize) * gridSize);
            var height = Math.abs(Math.round((pos.y - base.y) / gridSize) * gridSize);
            var offset = {
                x: Math.round((pos.x + base.x) / gridSize) * gridSize / 2,
                y: Math.round((pos.y + base.y) / gridSize) * gridSize / 2
            };
            this.trigger('change:size:end', {
                width: width,
                height: height
            }, offset);
        }
    });

    return Shape;
});



// WEBPACK FOOTER //
// ./common/ui/view/svg/shape/index.js